import { mapGetters } from 'vuex'

function AuthCheck(Comp, authList = [], redirect="/home") {
  return {
    data () {
      return {
        isAuthTest: false
      }
    },
    computed: {
      ...mapGetters('user', ['userInfo'])
    },
    render(h) {
      if (this.isAuthTest) {
        return h(Comp)
      }

      return null
    },
    watch: {
      userInfo: {
        handler () {
          if (authList.length === 0) {
            this.isAuthTest = true
          } else {
            if (authList.indexOf(this.userInfo.auth) !== -1) {
              this.isAuthTest = true
            } else {
              this.$showToast(this.$t('common.no_authorization'))
              this.$router.replace(redirect)
            }
          } 
        },
        immediate: true
      }
    }
  }
}

export default AuthCheck


// WEBPACK FOOTER //
// ./src/pages/components/AuthCheck.js